import Module from '../../../types/module';
import { InitializationSteps, InitializationStep, InitializationPromises } from '../../../types/initialization';
import { Store } from 'redux';
import { AlmeState } from '../../../wireup/AlmeState';
import { settings } from '../../../settings/settings-util';
import watch from 'redux-watch';

export default class Initialization extends Module{
    _initializationSteps: InitializationSteps; 
    _onLoadPromise: Promise<void>;
    _onLaunchPromise: Promise<void>;
    _onLoadResolve: Function;
    _onLaunchResolve: Function;


    constructor(initializationSteps: InitializationSteps, passedSettings?: typeof settings) {
        super(passedSettings);
        this._initializationSteps = initializationSteps;
        this._onLoadPromise = new Promise((resolve) => { this._onLoadResolve = resolve;});
        this._onLaunchPromise = new Promise((resolve) => { this._onLaunchResolve = resolve;});
    }

    initialize(store: Store<AlmeState>): InitializationPromises {
        super.initialize(store);
        
        return {
            onLoad: this._onLoadPromise,
            onLaunch: this._onLaunchPromise,
        } as InitializationPromises;
    }

    startApplicationInitialize(): void{
        this.loopThroughSteps(this._onLoadResolve, this._initializationSteps.onLoad);
        let previouslyActiveSession = false;
        let ivaIsEmbedded = false;
        this._onLoadPromise?.then(() => {
            const windowBase = this._settings.stateLocations.Window.Base;
            const minimizedLoc = this._settings.stateLocations.Window.IsMinimized;
            if(this._store?.getState()[windowBase][minimizedLoc]){
                const minimizedStateLocation = `${windowBase}.${minimizedLoc}`;
                const launchWatcher = watch(this._store.getState, minimizedStateLocation);
                const unsubscribe = this._store?.subscribe(launchWatcher((newVal) =>
                {
                    if (this._settings.disableIVAStateChange) {
                        if (!ivaIsEmbedded) {
                            if (!newVal) {
                                previouslyActiveSession = true;
                                this.loopThroughSteps(this._onLaunchResolve, this._initializationSteps.onLaunch);
                                unsubscribe();
                            }
                        }
                    }
                    else
                    {
                        if (!newVal) {
                            this.loopThroughSteps(this._onLaunchResolve, this._initializationSteps.onLaunch);
                            unsubscribe();
                        }
                    }

                }));
                if (this._settings.disableIVAStateChange) {
                    const isembedLoc = this._settings.stateLocations.Window.IsEmbedded;
                    const embedState = `${windowBase}.${isembedLoc}`;
                    const enbeddWatcher = watch(this._store.getState, embedState);
                    const embeddunsubscribe = this._store?.subscribe(enbeddWatcher((embeddnewVal) => {
                        if (!previouslyActiveSession) {
                            if (embeddnewVal) {
                                ivaIsEmbedded = true;
                                this.loopThroughSteps(this._onLaunchResolve, this._initializationSteps.onLaunch);
                                embeddunsubscribe();
                            }
                        }
                    }));
                }

            }
            else{
                this.loopThroughSteps(this._onLaunchResolve, this._initializationSteps.onLaunch);
            }
        });
    }

    loopThroughSteps(resolve, steps: InitializationStep[]): void {
        const stepsLoop = async function(): Promise<void> {
            for (const step of steps) {
                await step.getPromise();
            }
            resolve();
        };
        stepsLoop();
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialize/src/initialize.ts